exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".trophyRoom{height:545px}.trophyRoom .tierIcon{margin-top:2.5rem;height:5rem}.trophyRoom .shelfBackground{width:100%;position:absolute;left:0}.trophyRoom .tierRow{height:9rem}.trophyRoom .modalBackground{position:absolute;left:0;top:0;width:800px;height:575px;max-width:100%;max-height:100%;border-bottom-left-radius:5px;border-bottom-right-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/games/trophy_room.scss
// module id = 1331
// module chunks = 0